import { render, staticRenderFns } from "./RelatorioProdutosMaisVendidos.vue?vue&type=template&id=3845ba78"
import script from "./RelatorioProdutosMaisVendidos.vue?vue&type=script&lang=ts"
export * from "./RelatorioProdutosMaisVendidos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports